import React from "react";
import ProductSetupForm from "./ProductSetupForm/ProductSetupForm";
import KnowledgeBaseAccessControl from "components/dashboard/KnowledgeBase/KnowledgeBaseAccessControl/KnowledgeBaseAccessControl";
import { PRODUCT_CREATE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import "./ProductSetupView.scss";

const ProductSetupView = ({ retrieveProducts }) => {
    return (
        <div className='product-setup'>
            <div className='product-setup--container'>
                <div>
                    <h1 className='product-setup--text'>
                        Product Information Setup
                    </h1>
                    <p className='product-setup--sub__text'>
                        Add a new product information below to get started
                    </p>
                    <KnowledgeBaseAccessControl
                        baseResources={PRODUCT_CREATE_PERMISSION}>
                        <ProductSetupForm handleSuccess={retrieveProducts} />
                    </KnowledgeBaseAccessControl>
                </div>
            </div>
        </div>
    );
};

export default ProductSetupView;
